/**
 * Pojmenovaný filtr pro proklik z notifikace „končí platnost N smluv" ve zvonečku do seznamu smluv
 * (DEV-76). Notifikace posílá `?setFilter=finishedNotification&expirationDate=<datum>&resetFilter=true`
 * a effect seznamu nastaví filtr Stav jen na „ukončená". Datum zatím effect nečte — přesný filtr podle
 * data konce platnosti přijde v DEV-2555, proto ho notifikace posílá dál.
 *
 * Konstanta je tady, aby ji sdílel odesílatel (core/layout notification.service) i příjemce
 * (features/contracts seznam + jeho effecty) a string se nerozjel opisem.
 */
export const FINISHED_NOTIFICATION_FILTER = 'finishedNotification'

/** Query param s datem konce platnosti, který doprovází `setFilter=finishedNotification`. */
export const EXPIRATION_DATE_QUERY_PARAM = 'expirationDate'
